"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _iconsReact = require("../../../../icons-react");
// Icons

var DropdownButton = exports.DropdownButton = function DropdownButton(_ref) {
  var label = _ref.label,
    isOpen = _ref.isOpen,
    isFiltersMobile = _ref.isFiltersMobile;
  return /*#__PURE__*/_react["default"].createElement(StyledDropdownButton, null, label, !isFiltersMobile && /*#__PURE__*/_react["default"].createElement(StyledDropdownIcon, {
    $isOpen: isOpen
  }));
};
var StyledDropdownButton = _styledComponents["default"].span.withConfig({
  displayName: "DropdownButton__StyledDropdownButton",
  componentId: "sc-f7iyd3-0"
})(["white-space:nowrap;color:", ";"], function (props) {
  return props.theme.colors.blue;
});
var StyledDropdownIcon = (0, _styledComponents["default"])(_iconsReact.ArrowDown).withConfig({
  displayName: "DropdownButton__StyledDropdownIcon",
  componentId: "sc-f7iyd3-1"
})(["margin-left:3px;width:12px;height:6px;", " path{fill:", ";}"], function (props) {
  return !props.$isOpen && "\n    transform: rotate(180deg);\n  ";
}, function (props) {
  return props.theme.colors.blue;
});